import { Container } from 'react-bootstrap';
import GenericCard from './GenericCards';


function GenericCardsDemo() {
  return (
    <>
      <Container className='px-0 mx-0'>
        <GenericCard variant={'white'}>
          <h4>Generic Card White</h4>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit.
            Pellentesque euismod, nisl eget consectetur sagittis, nisl
            lectus consectetur nisi, eu aliquet nisl nisl eget nisl.
            Lorem ipsum dolor sit amet, consectetur adipiscing elit.
            Pellentesque euismod, nisl eget consectetur sagittis, nisl
            lectus consectetur nisi, eu aliquet nisl nisl eget nisl.
            Lorem ipsum dolor sit amet, consectetur adipiscing elit.
            Pellentesque euismod, nisl eget consectetur sagittis, nisl
            lectus consectetur nisi, eu aliquet nisl nisl eget nisl.
            Lorem ipsum dolor sit amet, consectetur adipiscing elit.
            Pellentesque euismod, nisl eget consectetur sagittis, nisl
            lectus consectetur nisi, eu aliquet nisl nisl eget nisl.
          </p>
        </GenericCard>
      </Container>
      <Container className='px-0 mx-0 mt-12'>
        <GenericCard variant={'gray'}>
          <h4>Generic Card Gray</h4>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit.
            Pellentesque euismod, nisl eget consectetur sagittis, nisl
            lectus consectetur nisi, eu aliquet nisl nisl eget nisl.
            Lorem ipsum dolor sit amet, consectetur adipiscing elit.
            Pellentesque euismod, nisl eget consectetur sagittis, nisl
            lectus consectetur nisi, eu aliquet nisl nisl eget nisl.
            Lorem ipsum dolor sit amet, consectetur adipiscing elit.
            Pellentesque euismod, nisl eget consectetur sagittis, nisl
            lectus consectetur nisi, eu aliquet nisl nisl eget nisl.
            Lorem ipsum dolor sit amet, consectetur adipiscing elit.
            Pellentesque euismod, nisl eget consectetur sagittis, nisl
            lectus consectetur nisi, eu aliquet nisl nisl eget nisl.
          </p>
        </GenericCard>
      </Container>
      <Container className='px-0 mx-0 mt-12'>
        <GenericCard variant={'red'}>
          <h4>Generic Card Red</h4>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit.
            Pellentesque euismod, nisl eget consectetur sagittis, nisl
            lectus consectetur nisi, eu aliquet nisl nisl eget nisl.
            Lorem ipsum dolor sit amet, consectetur adipiscing elit.
            Pellentesque euismod, nisl eget consectetur sagittis, nisl
            lectus consectetur nisi, eu aliquet nisl nisl eget nisl.
            Lorem ipsum dolor sit amet, consectetur adipiscing elit.
            Pellentesque euismod, nisl eget consectetur sagittis, nisl
            lectus consectetur nisi, eu aliquet nisl nisl eget nisl.
            Lorem ipsum dolor sit amet, consectetur adipiscing elit.
            Pellentesque euismod, nisl eget consectetur sagittis, nisl
            lectus consectetur nisi, eu aliquet nisl nisl eget nisl.
          </p>
        </GenericCard>
      </Container>
    </>
  );
}

export default GenericCardsDemo;
